module.exports = __webpack_public_path__ + "img/p2.51b5d41d.png";